import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const ZoomOutIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue900'}</MuiIcon>
        );
    }
)
